import { CommonRegEx } from '../validators/match.pattern.validator';

export class ThemeColors {
  // mocks found here https://projects.invisionapp.com/share/UXZBZG8YFDP#/screens
  public static readonly GraphColors = [
    '#3371b2', // single line chart
    '#9900CF', // electric violet
    '#13B0AB', // aqua
    '#87C93C', // atlantis
    '#D538C2', // cerise
    '#73726C', // tapa
    '#1C9AC0', // lake
    '#772AC9', // purple
    '#C7C83E', // earls green
    '#27A0FF', // dodger blue
    '#2A4EC9' // ocean blue
  ];

  public static readonly ThresholdColors = {
    Good: '#0070b8',
    Warning: '#f57902',
    Critical: '#d50032'
  };

  public static readonly lightTheme = {
    body: '#fafafa',
    ambientLight: '#ffffff',
    lowContrast: '#e5ecf5',
    highContrast: '#1e2027',
    mediumContrast: '#8692a2'
  };

  public static readonly darkTheme = {
    body: '#101F30',
    ambientLight: '#192737',
    lowContrast: '#2a3745',
    highContrast: '#ffffff',
    mediumContrast: '#8692a2'
  };

  /**
   * @param colorHex A 6 digit color hex (eg: #FF00AA)
   * @param opacity Desired opacity between 0 and 1
   * @returns An 8 digit color hex (eg: #FF00BBFF)
   */
  public static makeTransparent(colorHex: string, opacity: number): string {
    if (!this.isValid6DigitColorHex(colorHex)) {
      throw new Error('Invalid color hex. Expected format: #RRGGBB');
    }
    if (opacity < 0 || opacity > 1) {
      throw new Error('Opacity must be a value between 0 and 1');
    }
    // convert from decimal to hex
    const alphaHex = Math.round(opacity * 255)
      .toString(16)
      .toUpperCase()
      .padStart(2, '0');
    return colorHex + alphaHex;
  }

  // Will loop the initial set of colors provided to match the target items array.
  public static matchColorsToTargetItems(colors: string[], targetItemsLength: number): string[] {
    // return the initial set of colors when target is empty
    if (!targetItemsLength) {
      return colors;
    }
    if (!colors.length) {
      throw new Error('No colors provided.');
    }
    if (targetItemsLength <= colors.length) {
      return colors.slice(0, targetItemsLength);
    }
    // loop colors to match targetItemsLength
    let index = 0;
    const targetColors = [];
    while (index < targetItemsLength) {
      targetColors.push(colors[index % colors.length]);
      index += 1;
    }
    return targetColors;
  }

  /**
   * Validates a color hex string
   * @param colorHex A valid color hex has this format: #RRGGBB
   */
  public static isValid6DigitColorHex(colorHex: string): boolean {
    return CommonRegEx.COLOR_RRGGBB_REGEX.test(colorHex);
  }
}
